import clsx from 'clsx';

import DrupalImage from '@commons/components/Image/Drupal';
import FeaturedTile from '@commons/components/Tile/FeaturedTile';
import { FEATURED_TILE_IMAGE_SIZES } from '@commons/components/Tile/FeaturedTile';
import type { ContentAlignment } from '@commons/components/Tile/FeaturedTile';

import type { TileBlockProps } from '.';

/**
 * Featured variant of the Clickable Tile block.
 */

const TileBlockFeatured = ({ content }: TileBlockProps) => {
  const { image, title, description, tag, justify, disableScroll, link, aspectRatio, theme } =
    content;

  const renderedImage = <DrupalImage {...image} sizes={FEATURED_TILE_IMAGE_SIZES} />;

  const classes = clsx(!aspectRatio ? 'w-100 h-100' : 'w-100');

  return (
    <FeaturedTile
      theme={theme}
      tag={tag}
      title={title}
      disableScroll={disableScroll}
      description={description}
      buttonText={link.text}
      href={link.url}
      image={renderedImage}
      justify={justify as ContentAlignment}
      aspectRatio={aspectRatio}
      className={classes}
    />
  );
};

export default TileBlockFeatured;
